import React, { ReactNode } from 'react';
import { UserProfileStore } from './user-profile.store';

const UserProfileContext = React.createContext<UserProfileStore | null>(null);

export const UserProfileProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<UserProfileStore>(() => new UserProfileStore());

   return <UserProfileContext.Provider value={store}>{children}</UserProfileContext.Provider>;
};

export const useUserProfile = () => {
   const ctx = React.useContext(UserProfileContext);
   if (!ctx) {
      throw new Error('useUserProfile must be used inside UserProfileProvider');
   }
   return ctx;
};
